var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header1", { attrs: { title: "新手帮助" } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "new_content" }, [
      _c(
        "div",
        { staticClass: "use_xieyi", staticStyle: { color: "#666666" } },
        [
          _c("div", { staticClass: "use_xieyi_main" }, [
            _c(
              "div",
              { staticClass: "use_xieyi", staticStyle: { color: "#666666" } },
              [
                _c("div", { staticClass: "use_xieyi_main" }, [
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("1.为什么用手机号登录不成功？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              手机号需成功验证后才可做为帐号登录。验证手机号需登录后，点右上角头像下拉菜单→帐号设置→手机验证验证，进行验证设置。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("2.忘记密码怎么办？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              可点击登录框下方的忘记密码，通过已验证的手机号找回密码；也可通过关注微信公众号找回密码。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd_img" }, [
                    _c("img", {
                      attrs: {
                        height: "325",
                        src: require("../assets/img-4/weixin_findpwd.jpg"),
                        width: "714"
                      }
                    })
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("3.怎样修改密码？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              登录后，鼠标放在右上角个人信息处，有修改密码快捷选项；也可通过帐号设置快捷键，进入修改密码页面进行密码修改。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("4.为什么要绑定学习卡？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              为了不遗漏课程的学习、顺利申请学分及避免学习卡丢失，建议您登录学习中心后先进行学习卡绑定操作（若您手里没有学习卡可不用进行这项操作）。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("5.为什么注册不了帐号？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v("①确认证件号是否已被使用；"),
                    _c("br"),
                    _vm._v("\n              ②确认手机号是否已被使用；"),
                    _c("br"),
                    _vm._v(
                      "\n              ③确认是否已按注册要求完整填写个人信息；"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              ④您可能已注册过，请尝试用证件号或手机号登录；"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n              ⑤若上述均确认没问题，但还是注册不成功，可咨询在线客服或是电话400-822-2055。"
                    )
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("6.如何开始课程学习？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "登录后，点击进入学习中心，可在我的培训栏看到相应培训班的课程，点击课程即可开始学习。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd_img" }, [
                    _c("img", {
                      attrs: {
                        height: "607",
                        src: require("../assets/img-4/study_load.jpg"),
                        width: "788"
                      }
                    })
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("7.如何判断课程是否已完成学习？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v("课程状态显示为“已学完”则代表已完成本课程学习。")
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("8.如何申请学分？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              当学习状态为“已学完”时，方可申请学分；如您尚未绑定学习卡，则无法申请学分，为了您顺利的进行课程学习及证书申请，请先绑定学习卡。"
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("9.为何有些考试完成后看不到成绩？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              考试后是否能看到成绩是由管理员统一设置的，请与通知您考试的管理员联系或是拨打400-822-2055咨询。"
                    )
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("10.每场考试可以考几次？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "登录后进入“学习中心”，点击“我的考试”，即可看每场考试的“考试次数”。"
                    )
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _c("strong", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v("11.如何快速找到想学的继续医学教育项目？")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "pddpdd2" }, [
                    _vm._v(
                      "\n              登录后进入学习中心，即可看到正在开展的继续医学教育培训；可选择推荐项目进行学习，也可通过项目导航搜索您所喜欢的项目进行学习。"
                    )
                  ])
                ])
              ]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7074f9fb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7074f9fb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Help.vue
// module id = null
// module chunks = 